import { AccountManager } from './api/merchant/types';

export const project_colors = {
  NEUTRAL_LIGHT: '#DADADA',
  LIGHT_GREY: '#f5f9ff'
};

export const MAX_WIDTH = '468px';

export const CLASSIC_LOGIN = 'classic-login';
export const PASSWORDLESS_LOGIN = 'passwordless-login';
export const SOCIAL_LOGIN = 'social-login';
export const SHADOW_LOGIN = 'shadow';

export const PROJECT_LINKS = {
  FAQ: 'https://developers.xsolla.com/doc/login/references/faq/',
  DOCUMENTATION: 'https://developers.xsolla.com/doc/login/',
  PARTNER_SUPPORT: 'https://xsolla.com/partner-support',
  FEATURES: 'https://developers.xsolla.com/doc/login/features',
  OKTA: 'https://developers.xsolla.com/doc/login/extensions/authorization-via-okta/',
  CHAT: 'https://xsolla.com/partner-support#contactUs',
  OAUTH2: 'https://developers.xsolla.com/doc/login/features/connecting-oauth2',
  OAUTH2API:
    'https://developers.xsolla.com/doc/login/features/connecting-oauth2/#login_features_connecting_oauth2_app_side_integration_api',
  OAUTH2_WIDGET:
    'https://developers.xsolla.com/doc/login/features/connecting-oauth2/#login_features_connecting_oauth2_app_side_integration_widget',
  WIDGET_LANGUAGES:
    'https://developers.xsolla.com/doc/login/how-to/login-widget-sdk/#login_widget_sdk_api_calls_code_initialization_table_field_fulllocale'
};

export const API_DOCUMENTATION_LINKS = {
  DEVICE_ID: 'https://developers.xsolla.com/api/login/operation/jwt-auth-via-device-id/'
};

export const XSOLLA_ACCOUNT_DOCUMENTATION_LINKS = {
  SCOPE: '' // TODO insert a link to the documentation when it's ready.
};

export const SMS_LINKS = {
  AMAZON_SNS:
    'https://docs.aws.amazon.com/sns/latest/dg/sns-mobile-phone-number-as-subscriber.html',
  AMAZON_REGION:
    'https://docs.aws.amazon.com/sms-voice/latest/userguide/phone-numbers-sms-by-country.html',
  AMAZON_SENDER: 'https://docs.aws.amazon.com/sns/latest/dg/welcome.html',
  TWILIO_API: 'https://www.twilio.com/en-us/messaging',
  TWILIO_SID: 'https://www.twilio.com/docs/messaging/api#sms-api-authentication',
  TWILIO_TOKEN: 'https://www.twilio.com/docs/messaging/api#sms-api-authentication',
  TWILIO_SENDER: 'https://www.twilio.com/en-us/blog/personalize-sms-alphanumeric-sender-id',
  SINCH_API: 'https://developers.sinch.com/docs/sms/getting-started',
  SINCH_SERVICE_PLAN:
    'https://community.sinch.com/t5/SMS/How-do-I-create-an-SMS-Service-API/ta-p/8400',
  TELNYX_SENDER: 'https://developers.telnyx.com/docs/messaging/messages/send-message',
  TELNYX_API: 'https://developers.telnyx.com/docs/messaging/messages/send-message',
  SMSCENTER_API: 'https://smsc.ru/api',
  ALIBABA_CLOUD_SMS_API:
    'https://www.alibabacloud.com/help/en/short-message-service/latest/what-is-alibaba-cloud-sms'
};

export const EMAIL_LINKS = {
  SENDGRID_API_KEY: 'https://app.sendgrid.com/settings/api_keys'
};

export const MAILCHIMP_LINKS = {
  API: 'https://admin.mailchimp.com/account/api/',
  AUDIENCE: 'https://admin.mailchimp.com/audience/',
  PERMISSION: 'https://mailchimp.com/help/the-importance-of-permission/'
};

export const loginMethodsCdnUrl = {
  [PASSWORDLESS_LOGIN]:
    'https://cdn.xsolla.net/xsolla-login-widget/examples/json/passwordless-373437.json',
  [CLASSIC_LOGIN]: 'https://cdn.xsolla.net/xsolla-login-widget/examples/json/classic-0ed585.json',
  [SOCIAL_LOGIN]: 'https://cdn.xsolla.net/xsolla-login-widget/examples/json/social-8b69a7.json'
};

export const SHADOW_PROJECT_TYPE = 'shadow';
export const MASTER_PROJECT_TYPE = 'master';
export const BABKA_LOGIN_PROJECT_TYPE = 'babka-login';

export const AGREEMENT_STATUS_SIGNED = 'signed';
export const AGREEMENT_STATUS_WAITING = 'waiting';
export const AGREEMENT_STATUS_UNSIGNED = 'unsigned';

export const NOTIFICATION_LIFETIME = 20000;

export const DEFAULT_ACCOUNT_MANAGER: AccountManager = {
  email: 'am@xsolla.com',
  gravatar_url: null,
  id: null,
  is_deleted: null,
  locale: null,
  name: 'Contact us',
  phone: '+7 (495) 108-51-83',
  skype: null,
  user_name: null
};

export enum WidgetSteps {
  LoginStep = 'login_step',
  SignUpStep = 'sign-up_step',
  ConfirmPhoneStep = 'confirm_phone_step',
  ConfirmEmailStep = 'confirm_email_step',
  AskStep = 'ask_step',
  FinalSubmitStep = 'final_submit_step',
  SuccessSubmitStep = 'success_submit_step',
  InitPasswordlessEmailAuth = 'init_passwordless_email_auth_step',
  InitPasswordlessPhoneAuth = 'init_passwordless_phone_auth_step',
  InitEmailAuth = 'init_email_auth_step',
  InitUsernameAuth = 'init_username_auth_step',
  InitSocialAuth = 'init_social_auth_step',
  InitSignUp = 'init_sign-up_step',
  ConfirmPhoneVerification = 'confirm_phone_verification_step',
  ConfirmEmailVerification = 'confirm_email_verification_step',
  AskFormSkip = 'ask_form_skip_step',
  ConfirmAskPhone = 'confirm_ask_phone_step',
  ConfirmAskEmail = 'confirm_ask_email_step',
  OpenSocialsPageStep = 'open_socials_page_step'
}

export const DEFAULT_CUSTOM_OAUTH2_COLOR = '#d1d5db';

const DEFAULT_REDIRECT_URI = 'https://login.xsolla.com/api/social/oauth2/callback';

export const DEFAULT_XSOLLA_ACCOUNT_VALUES = {
  REDIRECT_URIS: [process.env.XSOLLA_ACCOUNT_DEFAULT_REDIRECT_URI ?? DEFAULT_REDIRECT_URI],
  MANDATORY_SCOPES: ['offline', 'email'],
  HIDDEN_SCOPES: ['offline'],
  IS_SCOPES_HIDDEN: true,
  PARTNER_OAUTH2_PAGE_URL:
    process.env.PARTNER_OAUTH2_PAGE_URL ?? 'https://wallet.xsolla.com/oauth2/profile'
};

export const CLIENT_SECRET_MASKED_STRING = '*******';

export const CDN_IMG_URL_REGEX = /https:\/\/cdn\.xsolla\.net\/.*\.(png|jpe?g)$/i;
